<template>
  <div class="Jieji">
    <div class="container">
      <h2>中文语言培训中心</h2>
      <p>我们把学习者实际语言交际能力的提高放在首位，要求每一位老师课上选用生活和工作中真实的语料以及更多的采用全目的语沉浸式教学，尽量形成一个接近真实的语言环境，通过一个个可操作的语言任务的构建和相关教学活动安排来激励学习者主动使用目的语。</p>

    </div>
    <van-tabs border
              animated
              title-active-color="#263e65">
      <van-tab title="6阶汉语标准课程">
        <div class="_conts">
          <van-collapse v-model="activeNames"
                        border>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">1.5个月以后（40课时）</span>
                  <span class="t2">A1</span>
                  <span class="t3">HSK1</span>
                  <span class="t4">￥999/$149</span>
                </div>
              </template>
              <div class="_tb_text">
                学会基本的生存汉语，能理解和使用汉语回答一些简单的问题，掌握150个常用词汇
              </div>
            </van-collapse-item>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">3个月以后（40课时）</span>
                  <span class="t2">A2</span>
                  <span class="t3">HSK2</span>
                  <span class="t4">￥999/$149</span>
                </div>
              </template>
              <div class="_tb_text">
                可以用汉语进行日常对话，就日常生活、工作、教育、文化、感觉等常见话题进行简单而直接的交流，掌握300个常用词汇
              </div>
            </van-collapse-item>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">6个月以后（80课时）</span>
                  <span class="t2">B1</span>
                  <span class="t3">HSK3</span>
                  <span class="t4">￥1499/$229</span>
                </div>
              </template>
              <div class="_tb_text">
                可以与汉语为母语者以一般语速正常交流，话题扩展到科技、自然、家居、交往等各个方面，并能熟练使用约800个常用汉字阅读简单无拼音标注的文章以及用汉语和朋友们发送短信和微信信息等，词汇量达到600
              </div>
            </van-collapse-item>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">10个月以后（120课时）</span>
                  <span class="t2">B2</span>
                  <span class="t3">HSK4</span>
                  <span class="t4">￥3999/$599</span>
                </div>
              </template>
              <div class="_tb_text">
                可以用汉语谈论经济、新闻、医疗、现象、就业等较为复杂的话题，表达更加规范和得体，能认识的汉字也更多，词汇量达到1200
              </div>
            </van-collapse-item>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">15个月以后（180课时）</span>
                  <span class="t2">C1</span>
                  <span class="t3">HSK5</span>
                  <span class="t4">￥7299/$1060</span>
                </div>
              </template>
              <div class="_tb_text">
                可以用汉语就文化、地理、体验感悟、文学艺术、金融、贸易等比较抽象或专业的话题进行讨论、评价和发表看法，较轻松地应对各种交际任务，同时也能阅读一般性的新闻和用汉语进行文书写作，词汇量达到2500
              </div>
            </van-collapse-item>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">22个月以后（280课时）</span>
                  <span class="t2"> C2</span>
                  <span class="t3">HSK6</span>
                  <span class="t4">￥11999/$1760</span>
                </div>
              </template>
              <div class="_tb_text">
                可以用汉语自如地进行各种社会交际活动，使用成语、俚语和其他习惯性表达，注意语体和语气，能进行更为专业的阅读和撰写各类文章，汉语应用水平接近汉语为母语者，词汇量达到5000
              </div>
            </van-collapse-item>
          </van-collapse>
          <div class="btns">
            <van-row>
              <van-col span="12">
                <a href="/mobile/about/3"
                   class="_btn">在线咨询</a>
              </van-col>
              <van-col span="12">
                <div class="_btn"
                     @click="onShowForm2('6阶汉语标准课程')">我要报名</div>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-tab>
      <van-tab title="汉字教程">
        <div class="_conts">
          <van-collapse v-model="activeNames"
                        border>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">2个月以后（50课时）</span>
                  <span class="t2">A1</span>
                  <span class="t3">400汉字</span>
                  <span class="t4">￥1249/$189</span>
                </div>
              </template>
              <div class="_tb_text">
                学会基本的生存汉语，能理解和使用汉语回答一些简单的问题，掌握150个常用词汇
              </div>
            </van-collapse-item>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">4.5个月以后（60课时）</span>
                  <span class="t2">A2</span>
                  <span class="t3">800汉字</span>
                  <span class="t4">￥1499/$229</span>
                </div>
              </template>
              <div class="_tb_text">
                可以基本看懂和编写日常汉语邮件、短信和微信内容，轻松地与中国亲朋好友、同事、客户、服务员、家政人员等进行书面交流，菜单、名片、车站显示屏上的汉字也可以轻松搞定，在中国生活不再困难，汉语达到HSK3级水
              </div>
            </van-collapse-item>
          </van-collapse>
          <div class="btns">
            <van-row>
              <van-col span="12">
                <a href="/mobile/about/3"
                   class="_btn">在线咨询</a>
              </van-col>
              <van-col span="12">
                <div class="_btn"
                     @click="onShowForm2('汉字教程')">我要报名</div>
              </van-col>
            </van-row>
          </div>
        </div>

      </van-tab>
      <van-tab title="商务汉语">
        <div class="_conts">
          <van-collapse v-model="activeNames"
                        border>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">3个月以后（60课时）</span>
                  <span class="t2">B1</span>
                  <span class="t3">BCT(A)</span>
                  <span class="t4">￥1499/$229</span>
                </div>
              </template>
              <div class="_tb_text">
                可用汉语进行一般性商务交流，包括介绍商品、祝愿、感谢、道别、应聘等，也可看懂会议通知、差旅安排以及简单的报价单、收支表、日程表、海关表、签证表等；学会一些简单的中国式商务礼仪和正式场合的表达方式；掌握...
              </div>
            </van-collapse-item>
            <van-collapse-item>
              <template #title>
                <div class="_tb_tit">
                  <span class="t1">9个月以后（200课时）</span>
                  <span class="t2">C1</span>
                  <span class="t3">BCT(B)</span>
                  <span class="t4">￥11999/$1760</span>
                </div>
              </template>
              <div class="_tb_text">
                可以自如地应对各种商务场合，进行专业的、地道的商务汉语交际；能理解、分析和评论各种财经、科技新闻；能看懂和拟写投诉信、简历、求职信、合同、项目报告、述职报告、商务报表、规章制度等各类正式商务文本；能参...
              </div>
            </van-collapse-item>
          </van-collapse>
          <div class="btns">
            <van-row>
              <van-col span="12">
                <a href="/mobile/about/3"
                   class="_btn">在线咨询</a>
              </van-col>
              <van-col span="12">
                <div class="_btn"
                     @click="onShowForm2('商务汉语')">我要报名</div>
              </van-col>
            </van-row>
          </div>
        </div>
      </van-tab>

    </van-tabs>
    <h2 style="color:#263e65;">选择班级</h2>
    <div class="xuanxiangka">
      <van-tabs border
                animated
                title-active-color="#263e65">
        <van-tab title="汉语一对一VIP班">
          <div class="_baoming">
            <p> 上课时间和课时数可灵活定制</p>
            <p> 每课时50分钟</p>
            <p> 支持Skype、微信授课</p>
            <div class="btn"
                 @click="onShowForm('汉语一对一VIP班')">
              点击报名
            </div>
          </div>
        </van-tab>
        <van-tab title="汉语标准小班">
          <div class="_baoming">
            <p> 每周4-20课时</p>
            <p> 每课时50分钟</p>
            <p> 每月循环开班</p>
            <p> 支持Skype、微信授课</p>
            <div class="btn"
                 @click="onShowForm('汉语标准小班')">
              点击报名
            </div>
          </div>
        </van-tab>
        <van-tab title="汉语标准大班">
          <div class="_baoming">
            <p> 每周4-20课时</p>
            <p> 每课时50分钟</p>
            <p> 每月循环开班</p>
            <p> 不支持Skype授课</p>
            <p> 20人封顶</p>
            <div class="btn"
                 @click="onShowForm('汉语标准大班')">
              点击报名
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>
    <div class="container">
      <div class="_lis">
        <div class="imgbox">
          <img src="@/assets/lx001.jpg"
               alt="">
        </div>
        <div class="text">
          <h5>助学一直致力于 <br> 协助提高社会整体语言应用能力</h5>
          <p>
            在日常学习和工作中你可能会遇到各种文书写作问题，如正式商务函件、简历及其他申请材料、法律文件、开会发言稿、报告等写作，若你对自己的文字功底还不太自信或者认为所写的内容缺乏亮点，那么你可以请助学的语言老师们来帮你指导、校正和润色，我们随时准备着为您提供语言方面的协助，让您的文案更为出彩。
          </p>
        </div>
      </div>
      <div class="_lis">
        <div class="imgbox">
          <img src="@/assets/lx002.jpg"
               alt="">
        </div>
        <div class="text">
          <h5>助学致力成为 <br> 汉语国际教育行业中国文化传播者</h5>
          <p>
            助学作为汉语国际教育行业的一员、中国文化的传播者以及国家汉办和众多高校国际交流学院的合作伙伴，一直致力于为就读和从事汉语国际教育专业的中外人士提供真实的研究素材和数据，也愿意为在华外国留学生及全球汉语学习者提供中文文章或论文写作专项指导。
          </p>
        </div>
      </div>
      <p class="_c">若您来到中国生活和工作，在出行、购物、交谈、租房等过程中遇到任何汉语沟通问题和其他生活问题，</p>
      <p class="_c">或者您是出国旅游、工作的中国同胞，在海外遇到了语言障碍，请不要犹豫，</p>
      <p class="_c"><b>即刻拨打助学服务热线 <br>（北京时间 周一 - 周五 09：00-17：30）</b></p>
      <p class="_c"><b style="color:#263e65;">+86-(0)10-62040776</b></p>
      <p class="_c">体验我们的 Hello ZHUXUE 服务</p>
      <p class="_c">该服务目前只对助学官网注册会员、各学习中心在读学员免费开放，且暂时仅支持汉语和英语。</p>
      <div class="shenqingTit">汉语角</div>
      <p>我们的汉语角属于微型国际语言文化交流活动，除了可以练习口语，还可以结交国内外新朋友。 *所有语言角都是30元/1.5小时，助学会员尊享免费1年。</p>
    </div>
    <div class="botline">
      没有更多了
    </div>
    <van-popup v-model="showForm"
               position="bottom"
               @closed="clearForm"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="FormCont">
        <ComForm @hideForm="hideForm"
                 :typeId=5
                 :formTitle="formtit"
                 ref="comForm"></ComForm>
      </div>
    </van-popup>

    <van-popup v-model="showForm2"
               position="bottom"
               @closed="clearForm2"
               :style="{ height: 'max-contant',maxHeight:'70%' }">
      <div class="formCont">
        <div class="head">
          {{formtit}}
        </div>
        <van-form @submit="onSubmit"
                  ref="formName">
          <van-field v-model="form1.name"
                     name="Name"
                     label="Name"
                     placeholder="Name"
                     :rules="[{ required: true, message: 'Please input your name' }]" />
          <van-field v-model="form1.phone"
                     name="Phone"
                     label="Phone"
                     placeholder="Phone"
                     :rules="[{ required: true, message: 'Please input your phone number' }]" />
          <van-field v-model="form1.email"
                     name="Email"
                     label="Email"
                     placeholder="Email"
                     :rules="[{ required: true, message: 'Please input your Email' }]" />

          <p class="beizhu">Note: Please leave your message, our consultant will contact you soon ASAP. <br>
            * Working Hours (Beijing time 9:00am-5:30pm Monday-Friday, except national holidays)</p>
          <div style="margin: 16px;">
            <van-button round
                        block
                        type="info"
                        native-type="submit">Subimt</van-button>
          </div>
        </van-form>
      </div>
    </van-popup>
  </div>
</template>

<script>
// @ is an alias to /src
import ComForm from '@/components/ComForm2'
import axiosApi from "../api/api.js";
import { Toast } from 'vant';
export default {
  name: 'Jieji',
  components: {
    ComForm
  },
  data () {
    return {
      activeNames: ['0'],
      showForm: false,
      showForm2: false,
      formtit: '',
      form1: {
        name: '',
        phone: '',
        email: '',
      },

    }
  },
  methods: {
    hideForm () {
      this.showForm = false
    },
    clearForm () {
      this.$refs.comForm.clearForm()
    },
    onShowForm (val) {
      this.formtit = val
      this.showForm = true
    },
    onShowForm2 (val) {
      this.formtit = val
      this.showForm2 = true
    },
    clearForm2 () {
      this.$refs.formName.resetValidation();
      this.form1 = {
        name: '',
        phone: '',
        email: '',
      }
    },
    onSubmit () {
      axiosApi('message', {
        form_type: 4,
        content: this.formTit,
        ...this.form1
      }, 'post').then(res => {
        if (res.data.status) {
          Toast.success('Success');
          this.showForm2 = false
          this.form1 = {
            name: '',
            phone: '',
            email: '',
          }
        } else {
          Toast.fail('Error, please try again');
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.Jieji {
  height: 100%;
  overflow: auto;
}
h2 {
  text-align: center;
}
p {
  margin-bottom: 20px;
  font-size: 28px;
  text-indent: 2em;
  &._c {
    text-align: center;
    text-indent: 0;
  }
}
.container {
  padding-bottom: 0;
  h4 {
    margin: 0;
  }
  font-size: 28px;

  .tips {
    color: #f29810;
    margin: 10px 0;
  }
  .tips_p {
    color: #545454;
  }
  .tips_lis {
    margin-top: 10px;
    color: #545454;
  }
  .tit1 {
    font-size: 32px;
    font-weight: bold;
    color: #f29810;
    text-align: center;
    margin-bottom: 20px;
  }
  .buzhu {
    h3 {
      margin-bottom: 20px;
      color: #263e65;
    }
    .lis {
      padding: 20px;
      box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
    }
  }
  .shenqingTit {
    border-left: 10px solid #263e65;
    line-height: 1;
    font-size: 32px;
    margin: 30px 0;
    padding-left: 10px;
  }
}

.cont-card {
  padding: 20px 0;
}
._conts {
  padding: 20px 0;
  ._tb_tit {
    display: flex;
    justify-content: space-between;
    span {
      font-size: 24px;
    }
    .t1 {
      text-align: center;
      width: 260px;
    }
    .t2 {
      text-align: center;
      width: 40px;
    }
    .t3 {
      text-align: center;
      width: 100px;
    }
    .t4 {
      text-align: center;
      width: 180px;
    }
  }
  ._tb_text {
    padding: 20px 0;
    color: #545454;
  }
  .btns {
    ._btn {
      display: block;
      background-color: #f6cb47;
      color: #fff;
      border-radius: 10px;
      padding: 20px 0;
      text-align: center;
      margin: 0 auto;
      margin-top: 20px;
      width: 95%;
    }
  }
}
.xuanxiangka {
  width: 700px;
  margin: 40px auto;
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
  border-radius: 15px;
  overflow: hidden;
}
._baoming {
  padding: 20px;
  p {
    text-indent: 0;
    text-align: center;
  }
  .btn {
    text-align: center;
    color: #263e65;
    font-weight: bold;
    font-size: 28px;
  }
}
._lis {
  box-shadow: 0px 0px 10px rgba($color: #000000, $alpha: 0.2);
  border-radius: 15px;
  margin-bottom: 40px;
  overflow: hidden;
  .text {
    padding: 20px;
    h5 {
      font-size: 36px;
      margin: 0;
      margin-bottom: 20px;
      color: #333;
    }
    p {
      text-indent: 0;
      color: #545454;
    }
  }
}
.formCont {
  padding-top: 20px;
  padding-bottom: 60px;
  .head {
    text-align: center;
    font-size: 36px;
    margin-bottom: 20px;
  }
  .beizhu {
    padding: 20px;
  }
}
</style>
<style lang="scss">
.van-step--finish .van-step__circle,
.van-step--finish .van-step__line {
  background-color: #263e65;
}
</style>
